import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { AppPermissions } from 'src/app/shared/app.permissions';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'ness-lepartner-view-form',
  templateUrl: './lepartner-view-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [".col-lg-4.col-md-5 { text-align: right; }", ".col-lg-8.col-md-7 { font-weight: 700; }"],
})
export class LEPartnerViewComponent implements OnInit, OnDestroy {
  @Input() isEventForm: boolean = false;
  @Input() isEditAllowed: boolean = true;
  @Output() closeForm = new EventEmitter<ServerModels.ENESS_LEPartnerDTO>();
  @Output() onLEPartnerEdit = new EventEmitter<ServerModels.ENESS_LEPartnerDTO>();
  apiRoot: string = environment.apiEndpoint;
  canEditLEPartner = AppPermissions.canEditLEPartner;
  private _destroyed$: Subject<void> = new Subject<void>();

  private _lePartner: ServerModels.ENESS_LEPartnerDTO;
  @Input() set lePartner(newPartner: ServerModels.ENESS_LEPartnerDTO) {
    this._lePartner = newPartner;
  }
  get lePartner(): ServerModels.ENESS_LEPartnerDTO {
    return this._lePartner;
  }

  private _authOrgCode: string;
  get authOrgCode(): string {
    return this._authOrgCode;
  }

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {
    window.setTimeout(() => {
      (<HTMLElement>this.elementRef.nativeElement).setAttribute("tabindex", "-1");
      (<HTMLElement>this.elementRef.nativeElement).focus();
    }, 1000);
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  public editLEPartner(): void {
    this.onLEPartnerEdit.emit(this.lePartner);
  }

  public onClose(): void {
    this.closeForm.emit(this.lePartner);
  }
}
